





















































import { Component, Vue } from 'vue-property-decorator';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { BButton, BIconPlus, BModal, BDropdown, BDropdownItem } from 'bootstrap-vue';
import DataTable from '@/components/DataTable.vue';
import ProjectFilterOptions from '@/types/ProjectFilterOptions';
import ProjectList from '@/components/ProjectList.vue';
import ProjectCardList from '@/components/ProjectCardList.vue';
import ProjectFilter from '@/components/ProjectFilter.vue';
import ProjectDetails from '@/components/ProjectDetails.vue';
import InlineSvg from 'vue-inline-svg';

@Component({
    components: {
        'default-layout': DefaultLayout,
        'b-btn': BButton,
        'b-icon-plus': BIconPlus,
        'b-dropdown': BDropdown,
        'b-dropdown-item': BDropdownItem,
        'b-modal': BModal,
        'data-table': DataTable,
        'project-list': ProjectList,
        'project-card-list': ProjectCardList,
        'project-filter': ProjectFilter,
        'project-details': ProjectDetails,
        'inline-svg': InlineSvg
    }
})
export default class ProjectsView extends Vue {
    projectId = ''
    showModal = false;
    refreshList = false;
    modalTitle = '';
    filter: ProjectFilterOptions = {
        sequenceOrName: null,
        isActive: true,
        clientId: null,
        projectManagerId: null
    };

    listLayouts: ListLayout[] = [
        {
            key: 1,
            icon: 'media/svg/icons/Text/Menu.svg',
            label: 'listLayoutLabels.listView'
        },
        {
            key: 2,
            icon: 'media/svg/icons/Layout/Layout-4-blocks.svg',
            label: 'listLayoutLabels.cardView',
        }
    ];

    layoutIcon = '';
    layoutLabel = '';
    selectedLayout = 1;

    mounted() {
        this.layoutIcon = this.listLayouts[0].icon;
        this.layoutLabel = this.listLayouts[0].label;
        this.selectedLayout = this.listLayouts[0].key;
    }

    setLayout(layout: ListLayout) {
        this.layoutIcon = layout.icon;
        this.layoutLabel = layout.label;
        this.selectedLayout = layout.key;
    }

    onLoadComplete() {
        this.refreshList = false;
    }

    onProjectSaved(result: boolean) {
        this.showModal = false;

        if (result) {
            this.refreshList = true;
        }
    }

    onProjectDeleted() {
        this.showModal = false;
        this.refreshList = true;
    }

    onProjectSelected(id: string) {
        this.projectId = id;
        this.modalTitle = this.$t('modal.projectDetailsTitle') as string;
        this.showModal = true;
    }

    addNewProject() {
        this.projectId = '';
        this.modalTitle = this.$t('modal.newProjectTitle') as string;
        this.showModal = true;
    }

    onFilterList(filter: ProjectFilterOptions) {
        this.filter = filter;
        this.refreshList = true;
    }
}

interface ListLayout {
    key: number;
    icon: string;
    label: string;
}
